import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import { MAX_TOTAL_DISMISSALS, FOURTEEN_DAYS_MS } from 'constants/passkeys';

const getTrackingData = () => {
    return Storage.local.getItem(LOCAL_STORAGE.PASSKEY_OPTIN_TRACKING) || {};
};

const isPasskeySupportedFn = async () => {
    if (!window.PublicKeyCredential) {
        return false;
    }

    try {
        return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
    } catch (error) {
        return false;
    }
};

const isPasskeyDisabled = async isEnabledEntryFlag => {
    const isPasskeySupported = await isPasskeySupportedFn();

    return !Sephora.configurationSettings?.passkey?.isPasskeyEnabled || !isPasskeySupported || !isEnabledEntryFlag;
};

const resetTracking = () => {
    Storage.local.removeItem(LOCAL_STORAGE.PASSKEY_OPTIN_TRACKING);
    const dismissedCount = Storage.local.getItem(LOCAL_STORAGE.PASSKEY_OPTIN_DISMISSED) || {};
    const count = (dismissedCount.count || 0) + 1;
    Storage.local.setItem(LOCAL_STORAGE.PASSKEY_OPTIN_DISMISSED, { count });
};

const trackDismissal = () => {
    let trackingData = getTrackingData();

    // Initialize tracking if not exists
    if (!trackingData?.count) {
        trackingData = { count: 0, lastDismissed: null, pauseUntil: null };
    }

    // Increment count
    trackingData.count += 1;
    trackingData.lastDismissed = new Date().getTime();

    if (trackingData.count >= MAX_TOTAL_DISMISSALS) {
        // Set 14-day pause
        trackingData.pauseUntil = new Date().getTime() + FOURTEEN_DAYS_MS;
    }

    Storage.local.setItem(LOCAL_STORAGE.PASSKEY_OPTIN_TRACKING, trackingData);
};

export default {
    isPasskeyDisabled,
    resetTracking,
    getTrackingData,
    trackDismissal
};
